import Vue from 'vue';
import Vuex from 'vuex';
import firedb from '@/firebaseInit';
import firebase from 'firebase';
import fetchTimeout from 'fetch-timeout';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        tournaments: [],
        teams: [],
        nextIds: {
            newPlayerId: 0,
            newTeamId: 0,
            newTournamentId: 0,
        },
        currentUser: null,
        status: "ok"
    },
    getters: {
        tournament: (state) => (tournamentId) => {
            for (var i = 0; i < state.tournaments.length; i++) {
                if (state.tournaments[i].id == tournamentId) {
                    return state.tournaments[i];
                }
            }
        },
        tournamentIndex: (state) => (tournamentId) => {
            for (var i = 0; i < state.tournaments.length; i++) {
                if (state.tournaments[i].id == tournamentId) {
                    return i;
                }
            }
        },
        teamIdsByTournament: (state, getters) => (tournamentId) => {
            console.log(getters.tournament(tournamentId).teams)
            console.log(getters.tournament(tournamentId).teams.map(team => team.id));
            return getters.tournament(tournamentId).teams.map(team => team.id);
        },
        teamIndex: (state) => (teamId) => {
            for (var i = 0; i < state.teams.length; i++) {
                if (state.teams[i].id == teamId) {
                    return i;
                }
            }
        },
        team: (state) => (teamId) => {
            for (var i = 0; i < state.teams.length; i++) {
                if (state.teams[i].id == teamId) {
                    return state.teams[i];
                }
            }
        }

    },
    mutations: {

        //ADD TOURNAMENT

        addTournament: (store, newTournament) => {
            store.tournaments.push(newTournament);
            store.nextIds.newTournamentId++;
        },

        //REMOVE TOURNAMENT

        removeTournament: (store, tournamentId) => {
            for (var i = 0; i < store.tournaments.length; i++) {
                if (store.tournaments[i].id === tournamentId) {
                    store.tournaments.splice(i, 1);
                }
            }
        },

        //EDITS TO TOURNAMENT:

        //----ADD TEAM

        addNewTeam: (store, payload) => {

            store.teams.push(payload.team);
            for (var i = 0; i < store.tournaments.length; i++) {
                if (store.tournaments[i].id === payload.tournamentId) {
                    store.tournaments[i].teams.push(payload.team.id);
                }
            }
            store.nextIds.newTeamId++;
        },

        addExistingTeam: (store, payload) => {
            store.tournaments[payload.tournamentIndex].teams.push(payload.teamId)
        },

        //----REMOVE TEAM

        removeTeam: (store, teamId) => {
            for (var i = 0; i < store.teams.length; i++) {
                if (store.teams[i].id === teamId) {
                    store.teams.splice(i, 1);
                }
            }
            for (var j = 0; j < store.tournaments.length; j++) {
                for (var k = 0; k < store.tournaments[j].teams.length; k++) {
                    if (store.tournaments[j].teams[k] == teamId) {
                        store.tournaments[j].teams.splice(k, 1);
                    }
                }
            }
        },

        removeTeamFromTournament: (store, payload) => {
            store.tournaments[payload.tournamentIndex].teams.splice(payload.teamIndex, 1);
        },

        //----UPDATE BRACKET

        setTeamInBracket: (store, payload) => {
            Vue.set(store.tournaments[payload.tournamentIndex].bracket[payload.stage][payload.game], payload.team, payload.newTeam);
        },

        resetBracket: (store, tournamentIndex) => {
            store.tournaments[tournamentIndex].bracket = []
            store.tournaments[tournamentIndex].status.status = "UPCOMING"
            store.tournaments[tournamentIndex].status.winner = null
        },

        updateWinnerInBracket: (store, payload) => {
            var tournamentIndex;
            for (var i = 0; i < store.tournaments.length; i++) {
                if (store.tournaments[i].id === payload.tournamentId) {
                    tournamentIndex = i;
                }
            }
            var stage = payload.stage - 1;
            var game = payload.game / 2;
            game = Math.floor(game);
            var team = payload.game % 2;

            //If team is already set as winner, revert win
            if (store.tournaments[tournamentIndex].bracket[stage][game][team] == payload.teamId) {
                Vue.set(store.tournaments[tournamentIndex].bracket[stage][game], team, null);
                //Else set as winner
            } else {
                Vue.set(store.tournaments[tournamentIndex].bracket[stage][game], team, payload.teamId);
            }
        },

        generateBracket: (store, payload) => {
            var teamIndex = 0;
            if (payload.teams.length == 4) {
                store.tournaments[payload.tournamentIndex].bracket = [[[null, null]], [[], []]];

                //Fill stage 1
                for (var j = 0; j < 2; j++) {
                    for (var k = 0; k < 2; k++) {
                        store.tournaments[payload.tournamentIndex].bracket[1][j].push(payload.teams[teamIndex]);
                        teamIndex++;
                    }
                }
            } else if (payload.teams.length == 8) {
                store.tournaments[payload.tournamentIndex].bracket = [[[null, null]], [[null, null], [null, null]], [[], [], [], []]];

                //Fill stage 2
                for (j = 0; j < 4; j++) {
                    for (k = 0; k < 2; k++) {
                        store.tournaments[payload.tournamentIndex].bracket[2][j].push(payload.teams[teamIndex]);
                        teamIndex++;
                    }
                }
            }
        },

        setTournamentStatus: (store, payload) => {
            store.tournaments[payload.tournamentIndex].status.status = payload.status
            store.tournaments[payload.tournamentIndex].status.winner = payload.winner
        },

        //EDITS TO TEAM

        //----ADD PLAYER

        addPlayerToTeam: (store, payload) => {
            store.teams[payload.teamIndex].players.push(payload.player);
            store.nextIds.newPlayerId++;
        },

        //----REMOVE PLAYER

        removePlayer: (store, payload) => {
            for (var i = 0; i < store.teams[payload.teamIndex].players.length; i++) {
                if (store.teams[payload.teamIndex].players[i].id === payload.playerId) {
                    store.teams[payload.teamIndex].players.splice(i, 1);
                }
            }
        },

        //----UPDATE TEAM STATS

        setTeamStats: (store, payload) => {
            store.teams[payload.teamIndex].teamStats = payload.stats;
        },



        //OTHER

        setCurrentUser: (store, user) => {
            store.currentUser = user;
        },

        resetData: store => {
            store.tournaments = [],
                store.teams = [],
                store.nextIds = {
                    newPlayerId: 0,
                    newTeamId: 0,
                    newTournamentId: 0,
                }
            console.log("Data reset!")
        },

        setStatus: (store, status) => {
            store.status = status
            console.log("Status is " + status)
        },

        //GET FROM FIRESTORE

        addTournamentFromFirestore: (store, tournament) => {
            store.tournaments.push(tournament);
        },
        addTeamFromFirestore: (store, team) => {
            store.teams.push(team);
        },
        setUserDataFromFirestore: (store, nextIds) => {
            store.nextIds = nextIds;
        }

    },
    actions: {
        signup: (context, payload) => {
            firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                .then(
                user => {
                    context.commit('setCurrentUser', user);
                    firedb.collection("users").doc(firebase.auth().currentUser.uid).set({
                        nextIds: context.state.nextIds
                    }).catch(err => {
                        console.log("Error with creating firestore document for new user" + err);
                    })
                    payload.callback();
                },
                err => {
                    payload.errorCallback(err.message);
                })
        },

        login: (context, payload) => {
            firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                .then(
                user => {
                    context.commit('setCurrentUser', user);
                    context.dispatch('getTournamentsFromFirestore');
                    context.dispatch('getTeamsFromFirestore');
                    context.dispatch('getUserStateFromFirestore');
                    payload.callback();
                },
                err => {
                    payload.errorCallback(err.message);
                })
        },
        logout: (context, payload) => {
            firebase.auth().signOut()
                .then(
                () => {
                    context.commit('setCurrentUser', null);
                    context.commit('resetData');
                    payload.callback();
                },
                err => {
                    payload.errorCallback(err.message);
                })
        },

        //Source: https://medium.com/@kaungmyatlwin/wrapping-firebase-current-user-with-vuex-store-da33718d21c7
        checkUserStatus: context => {
            return new Promise((resolve, reject) => {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        context.commit('setCurrentUser', user);
                        resolve(user);
                    } else {
                        reject('User is not logged in.');
                    }
                });
            });
        },

        getEverythingFromFirestore: context => {
            context.commit('setStatus', "loading")
            console.log("Getting everything from firestore!")
            context.commit('resetData')
            context.dispatch('getTournamentsFromFirestore')
            context.dispatch('getTeamsFromFirestore')
            context.dispatch('getUserStateFromFirestore')
        },

        getTournamentsFromFirestore: context => {
            firedb.collection('users').doc(firebase.auth().currentUser.uid).collection('tournaments').get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {

                        var tournament = doc.data()
                        var bracket = tournament.bracket
                        var newBracket;

                        if (bracket.length == 6) {
                            newBracket = [[[bracket[0], bracket[1]]], [[bracket[2], bracket[3]], [bracket[4], bracket[5]]]]
                            tournament.bracket = newBracket
                        }
                        if (bracket.length == 14) {
                            newBracket = [[[bracket[0], bracket[1]]], [[bracket[2], bracket[3]], [bracket[4], bracket[5]]], [[bracket[6], bracket[7]], [bracket[8], bracket[9]], [bracket[10], bracket[11]], [bracket[12], bracket[13]]]]
                            tournament.bracket = newBracket
                        }
                        context.commit('addTournamentFromFirestore', tournament);
                    })
                })
                .then(() => {
                    console.log("Successfully fetched tournaments from firestore");
                })
                .catch(err => {
                    console.log("Error when fetching tournaments from firestore: " + err);
                })
        },
        getTeamsFromFirestore: context => {
            firedb.collection('users').doc(firebase.auth().currentUser.uid).collection('teams').get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        context.commit('addTeamFromFirestore', doc.data());

                    })
                })
                .then(() => {
                    console.log("Successfully fetched teams from firestore");
                })
                .catch(err => {
                    console.log("Error when fetching teams from firestore: " + err);
                })
        },
        getUserStateFromFirestore: context => {
            firedb.collection('users').doc(firebase.auth().currentUser.uid).get()
                .then(doc => {
                    context.commit('setUserDataFromFirestore', doc.data().nextIds);

                })
                .then(() => {
                    console.log("Successfully fetched user data from firestore");
                    context.commit('setStatus', "ok")
                })
                .catch(err => {
                    console.log("Error when fetching user data from firestore: " + err);
                    context.commit('setStatus', "ok")
                })
        },
        saveTournamentToFirestore: (context, tournament) => {
            firedb.collection('users').doc(context.state.currentUser.uid).collection('tournaments').add(tournament)
                .then(() => {
                    console.log("Successfully saved new tournament to firestore");
                    firedb.collection('users').doc(context.state.currentUser.uid).update({
                        nextIds: context.state.nextIds
                    })
                        .then(() => {
                            console.log("Updated user state in firestore");
                        })
                        .catch(() => {
                            console.log("Error when updating user state in firestore");
                        })
                })
                .catch(err => {
                    console.log("Error when saving new tournament to firestore: " + err);
                })
        },
        updateTournamentInFirestore: (context, tournamentId) => {
            var tournament = context.getters.tournament(tournamentId);

            var tournamentCopy = {}
            tournamentCopy["id"] = tournament.id
            tournamentCopy["name"] = tournament.name
            tournamentCopy["teams"] = tournament.teams
            tournamentCopy["status"] = tournament.status

            var newBracket = []

            for (var i = 0; i < tournament.bracket.length; i++) {
                for (var j = 0; j < tournament.bracket[i].length; j++) {
                    for (var k = 0; k < tournament.bracket[i][j].length; k++) {
                        newBracket.push(tournament.bracket[i][j][k])
                    }
                }
            }

            tournamentCopy["bracket"] = newBracket

            firedb.collection('users').doc(context.state.currentUser.uid).collection('tournaments').where("id", "==", tournamentId).get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        doc.ref.set(tournamentCopy);
                    })
                })
                .then(() => {
                    console.log("Successfully updated tournament ", tournament.name, " in firestore");
                })
                .catch(err => {
                    console.log("Error when updating tournament", tournament.name, " in firestore: " + err);
                })
        },
        deleteTournamentFromFirestore: (context, tournamentId) => {
            firedb.collection('users').doc(context.state.currentUser.uid).collection('tournaments').where("id", "==", tournamentId).get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        doc.ref.delete();
                    })
                })
                .then(() => {
                    console.log("Successfully deleted tournament with id ", tournamentId, " from firestore");
                })
                .catch(err => {
                    console.log("Error when deleting tournament with id ", tournamentId, " from firestore: " + err);
                })
        },
        saveTeamToFirestore: (context, team) => {
            firedb.collection('users').doc(context.state.currentUser.uid).collection('teams').add(team)
                .then(() => {
                    console.log("Successfully saved new team to firestore");
                    firedb.collection('users').doc(context.state.currentUser.uid).update({
                        nextIds: context.state.nextIds
                    })
                        .then(() => {
                            console.log("Updated user state in firestore");
                        })
                        .catch(() => {
                            console.log("Error when updating user state in firestore");
                        })
                })
                .catch(err => {
                    console.log("Error when saving new team to firestore: " + err);
                })
        },
        updateTeamInFirestore: (context, teamId) => {
            var team = context.getters.team(teamId);

            firedb.collection('users').doc(context.state.currentUser.uid).collection('teams').where("id", "==", teamId).get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        doc.ref.set(team);
                    })
                })
                .then(() => {
                    console.log("Successfully updated team ", team.name, " in firestore");
                })
                .catch(err => {
                    console.log("Error when updating team", team.name, " in firestore: " + err);
                })
        },
        deleteTeamFromFirestore: (context, teamId) => {
            firedb.collection('users').doc(context.state.currentUser.uid).collection('teams').where("id", "==", teamId).get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        doc.ref.delete();
                    })
                })
                .then(() => {
                    console.log("Successfully deleted team with id ", teamId, " from firestore");
                })
                .catch(err => {
                    console.log("Error when deleting team with id ", teamId, " from firestore: " + err);
                })
        },




        //ADD TOURNAMENT

        createTournament: (context, tournamentName) => {
            var newTournament = {
                id: context.state.nextIds.newTournamentId,
                name: tournamentName,
                teams: [],
                bracket: [],
                status: { status: "UPCOMING", winner: null }
            }
            context.commit('addTournament', newTournament);
            context.dispatch('saveTournamentToFirestore', newTournament);
        },

        //REMOVE TOURNAMENT

        removeTournament: (context, tournamentId) => {
            context.commit('removeTournament', tournamentId);
            context.dispatch('deleteTournamentFromFirestore', tournamentId);
        },

        //EDITS TO TOURNAMENT

        //----ADD TEAM

        addNewTeam: (context, payload) => {
            var newTeam = {
                name: payload.teamName,
                id: context.state.nextIds.newTeamId,
                players: [],
                teamStats: null
            }
            context.commit('addNewTeam', { team: newTeam, tournamentId: payload.tournamentId });
            context.commit('resetBracket', context.getters.tournamentIndex(payload.tournamentId))
            context.dispatch('updateTournamentInFirestore', payload.tournamentId);
            context.dispatch('saveTeamToFirestore', newTeam);
        },

        addExistingTeam: (context, payload) => {
            var teamId = parseInt(payload.teamId)
            var allTeamIds = context.state.teams.map(team => team.id)
            var teamIdsInTournament = context.getters.tournament(payload.tournamentId).teams.map(id => id)


            var tournamentIndex = context.getters.tournamentIndex(payload.tournamentId)
            if (allTeamIds.includes(teamId) && !(teamIdsInTournament).includes(teamId)) {
                context.commit('addExistingTeam', { teamId: teamId, tournamentIndex: tournamentIndex })
            }
            context.commit('resetBracket', tournamentIndex)
            context.dispatch('updateTournamentInFirestore', payload.tournamentId);



        },

        //----REMOVE TEAM

        removeTeamFromTournament: (context, payload) => {
            var tournamentIndex = context.getters.tournamentIndex(payload.tournamentId);
            //Remove team from bracket
            for (var stage = 0; stage < context.getters.tournament(payload.tournamentId).bracket.length; stage++) {
                for (var game = 0; game < context.getters.tournament(payload.tournamentId).bracket[stage].length; game++) {
                    for (var team = 0; team < context.getters.tournament(payload.tournamentId).bracket[stage][game].length; team++) {
                        if (context.getters.tournament(payload.tournamentId).bracket[stage][game][team] == payload.teamId) {
                            context.commit('setTeamInBracket', { tournamentIndex: tournamentIndex, stage: stage, game: game, team: team, newTeam: null })
                        }
                    }
                }
            }
            for (var j = 0; j < context.state.tournaments[tournamentIndex].teams.length; j++) {
                if (context.state.tournaments[tournamentIndex].teams[j] == payload.teamId) {
                    context.commit('removeTeamFromTournament', { tournamentIndex: tournamentIndex, teamIndex: j })
                }
            }
            context.dispatch('updateTournamentInFirestore', payload.tournamentId);
        },

        removeTeam: (context, teamId) => {
            for (var i = 0; i < context.state.tournaments.length; i++) {
                if (context.state.tournaments[i].teams.includes(teamId)) {
                    context.dispatch('removeTeamFromTournament', { tournamentId: context.state.tournaments[i].id, teamId: teamId })
                    context.dispatch('updateTournamentInFirestore', context.state.tournaments[i].id)
                }
            }
            context.commit('removeTeam', teamId);
            context.dispatch('deleteTeamFromFirestore', teamId);
        },

        //----UPDATE BRACKET

        generateBracket: (context, tournamentId) => {
            var teams = context.getters.tournament(tournamentId).teams;
            var teamsCopy = []

            for (var j = 0; j < teams.length; j++) {
                teamsCopy.push(teams[j])
            }

            //Add null to fill 8 spots
            if (teamsCopy.length >= 5 && teamsCopy.length <= 8) {
                for (var i = teamsCopy.length; i < 8; i++) {
                    teamsCopy.push(null);
                }
            }

            //Shuffle teams
            //Source: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
            var currentIndex = teamsCopy.length, temporaryValue, randomIndex;
            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = teamsCopy[currentIndex];
                teamsCopy[currentIndex] = teamsCopy[randomIndex];
                teamsCopy[randomIndex] = temporaryValue;
            }
            var tournamentIndex = context.getters.tournamentIndex(tournamentId);
            context.commit('generateBracket', {
                tournamentId: tournamentId,
                teams: teamsCopy,
                tournamentIndex: tournamentIndex
            });
            context.commit('setTournamentStatus', { status: "IN PROGRESS", winner: null, tournamentIndex: tournamentIndex })


            context.dispatch('updateTournamentInFirestore', tournamentId);
        },
        updateWinnerInBracket: (context, payload) => {
            var tournamentIndex = context.getters.tournamentIndex(payload.tournamentId);

            var stage = payload.stage - 1;
            var game = payload.game / 2;
            game = Math.floor(game);
            var team = payload.game % 2;

            //If team is already set as winner, revert win
            if (context.state.tournaments[tournamentIndex].bracket[stage][game][team] == payload.teamId) {
                context.commit('setTeamInBracket', { tournamentIndex: tournamentIndex, stage: stage, game: game, team: team, newTeam: null });
                //Else set as winner
            } else {
                context.commit('setTeamInBracket', { tournamentIndex: tournamentIndex, stage: stage, game: game, team: team, newTeam: payload.teamId });
            }

            context.dispatch('updateTournamentInFirestore', payload.tournamentId);


        },

        setTournamentStatus: (context, payload) => {
            var tournamentIndex = context.getters.tournamentIndex(payload.tournamentId)
            payload["tournamentIndex"] = tournamentIndex
            context.commit('setTournamentStatus', payload)
        },

        //EDITS TO TEAM

        //----ADD PLAYER

        getPlayerFromAPI: (context, parameters) => {
            //Get stats
            fetchTimeout('https://owapi.net/api/v3/u/' + parameters.battleTag + '/stats', {
                method: 'GET'
              }, 10000, 'Something went wrong. Please check your internet connection.')
                .then(response => {
                    if (response.ok) {
                        console.log("API1 OK");
                        return response.json();
                    } else {
                        console.log("API1 ERROR");
                        throw response;
                    }
                })
                .then(response => {
                    //Get hero stats
                    fetchTimeout('https://owapi.net/api/v3/u/' + parameters.battleTag + '/heroes', {
                    method: 'GET'
                        }, 10000, 'Something went wrong. Please check your internet connection.')
                        .then(response2 => {
                            if (response2.ok) {
                                console.log("API2 OK");
                                return response2.json();
                            } else {
                                console.log("API2 ERROR");
                                throw response2;
                            }

                        })
                        .then(response2 => {
                            var player = {};
                            player["playtime"] = response2.eu.heroes.playtime;
                            player["name"] = parameters.battleTag;
                            player["id"] = context.state.nextIds.newPlayerId;

                            var playerStats = {
                                competitive: {
                                    competitive: response.eu.stats.competitive.competitive,
                                    game_stats: response.eu.stats.competitive.game_stats,
                                    overall_stats: response.eu.stats.competitive.overall_stats
                                },
                                quickplay: {
                                    game_stats: response.eu.stats.quickplay.game_stats,
                                    overall_stats: response.eu.stats.quickplay.overall_stats
                                }
                            };
                            player["stats"] = playerStats;

                            var teamIndex = context.getters.teamIndex(parameters.teamId);
                            context.commit('addPlayerToTeam', { player: player, teamId: parameters.teamId, teamIndex: teamIndex });
                            context.dispatch('calculateTeamStats', parameters.teamId)
                            context.dispatch('updateTeamInFirestore', parameters.teamId);
                            firedb.collection('users').doc(context.state.currentUser.uid).update({
                                nextIds: context.state.nextIds
                            })
                                .then(() => {
                                    console.log("Updated user state in firestore");
                                })
                                .catch(() => {
                                    console.log("Error when updating user state in firestore");
                                })
                            parameters.callback();

                        }).catch(error2 => {
                            console.error('Error2:', error2)
                            parameters.errorCallback(error2.status);
                        })
                })
                .catch(error => {
                    console.error('Error1:', error)
                    parameters.errorCallback(error.status);
                })
        },

        //----REMOVE PLAYER

        removePlayer: (context, payload) => {
            var teamIndex = context.getters.teamIndex(payload.teamId);
            payload["teamIndex"] = teamIndex;
            context.commit('removePlayer', payload);
            context.dispatch('updateTeamInFirestore', payload.teamId);
        },

        //----UPDATE TEAM STATS

        calculateTeamStats: (context, teamId) => {
            var team = context.getters.team(teamId);
            var teamStats = {
                avgRank: 0,
                avgDmgDone: 0,
                avgEliminations: 0,
                avgHealingDone: 0,
                avgWinRate: 0
            }

            var numberOfPlayersWithCompetitiveStats = 0;
            for (var i = 0; i < team.players.length; i++) {
                var playerStats;
                var gamesPlayed;

                if (team.players[i].stats.competitive != null && team.players[i].stats.competitive.overall_stats.games >= 10) {
                    playerStats = team.players[i].stats.competitive;
                    gamesPlayed = playerStats.game_stats.games_played;

                    teamStats.avgRank += playerStats.overall_stats.comprank;
                    teamStats.avgDmgDone += (playerStats.game_stats.damage_done / gamesPlayed);
                    teamStats.avgEliminations += (playerStats.game_stats.eliminations / gamesPlayed);
                    teamStats.avgHealingDone += (playerStats.game_stats.healing_done / gamesPlayed);
                    teamStats.avgWinRate += (playerStats.overall_stats.win_rate);
                    numberOfPlayersWithCompetitiveStats++;
                }
            }

            if (numberOfPlayersWithCompetitiveStats > 0) {
                for (var key in teamStats) {
                    if (teamStats.hasOwnProperty(key)) {
                        teamStats[key] = teamStats[key] / numberOfPlayersWithCompetitiveStats;
                    }
                }
            }
            var teamIndex = context.getters.teamIndex(team.id);
            context.commit('setTeamStats', { stats: teamStats, teamId: team.id, teamIndex: teamIndex });
            context.dispatch('updateTeamInFirestore', teamId)



        },

        setStatus: (context, status) => {
            context.commit('setStatus', status)
        }


    }


});



// WEBPACK FOOTER //
// ./src/store/store.js